module.exports = __webpack_public_path__ + "static/media/IconTemplates_-39.65596576.svg";